module.exports = __webpack_public_path__ + "img/viaLogo_photo1.7d909da5.svg";